import(/* webpackMode: "eager", webpackExports: ["keywords"] */ "/home/vantagediesel.com/vantage-diesel/app/keywords.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vantagediesel.com/vantage-diesel/components/magicui/word-rotate.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vantagediesel.com/vantage-diesel/components/parallax.jsx");
;
import(/* webpackMode: "eager" */ "/home/vantagediesel.com/vantage-diesel/node_modules/next/dist/client/image-component.js");
